import { api } from '../config/base-api';
import { CheckoutSession } from 'hooks/useCheckoutSession';

export async function getCheckoutSession(cartId: string): Promise<CheckoutSession> {
  const res = await api.get<CheckoutSession>(`/api/v1/sessions/checkout/${cartId}`);
  return res.data;
}
